<article class="forget-password-page">
  <div>
    <section class="university-name-container">
      <figure>
        <img src="images/aum-logo.png" alt="aum Logo" />
      </figure>
      <p>{{ "universityName" | translate }}</p>
    </section>
    <section class="forget-password-form-container">
      <div class="form-intro">
        <p>{{ "forgetPassword.intro.forgetPassword" | translate }}</p>
        <p>{{ "forgetPassword.intro.p" | translate }}</p>
      </div>

      <form
        [formGroup]="forgetPasswordForm"
        (ngSubmit)="onSubmit()"
        class="forget-password-form"
      >
        <app-text-input
          [textControl]="this.forgetPasswordForm.controls['email']"
          [config]="{
            placeholder: 'forgetPassword.form.email' | translate,
            minLength: 5,
            maxLength: 320,
            icon: 'username',
            preventSpace: true,
            'margin-block-end': '0'
          }"
        ></app-text-input>

        <app-form-button
          [config]="{
            text: 'forgetPassword.form.button' | translate,
            form: this.forgetPasswordForm,
            type: 'submit',
          }"
        ></app-form-button>
        <div class="first-time-login">
          <a routerLink="/auth/login" ariaCurrentWhenActive="page">{{
            "login.intro.login" | translate
          }}</a>
        </div>
      </form>
      <footer>
        Copyright &copy; 2023-{{ this.currentYear }} by
        <a target="_blank" href="https://code-mint.com/">CodeMint</a>
      </footer>
    </section>
  </div>
</article>
<figure class="login-top-right-shape">
  <img src="svgs/login/login-top-right-shape.svg" alt="" />
</figure>
<figure class="login-bottom-left-shape">
  <img src="svgs/login/login-bottom-left-shape.svg" alt="" />
</figure>
<section class="logo-container">
  <figure>
    <img src="svgs/app/full-eduminty-logo.svg" alt="EduMinty logo" />
  </figure>
</section>
